firebird.factory('videoLayoutService', [
    '$rootScope',
    '$timeout',
    '$window',
    'logService',
    'socketService',
    'attendeeListService',
    'configService',
    'videoroomService',
    'videoLayoutAlgorithmService',
    'videoGlobalService',
    'annotationService',
    'helperService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $timeout,
        $window,
        logService,
        socketService,
        attendeeListService,
        configService,
        videoroomService,
        videoLayoutAlgorithmService,
        videoGlobalService,
        annotationService,
        helperService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize,
            getShowWebcams: getShowWebcams,
            setShowWebcams: setShowWebcams
        };

        var self, $scope;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoLayoutService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initLayout = initLayout;

            // the layout algorithm to apply. can be changed using URL param layoutMethod.
            // default is to use flexible aspect ratio for < 12 videos, and landscape for more,
            // and fill as much of screen as possible.
            self.layoutMethod = null;
            self.maxVideoCountForFlexibleLayout = 11;

            // URL param can be used to alter this: layoutTrigger=click or dblclick (default, null) or oneclick or none
            self.layoutTrigger = null;
            self.layoutTriggerLast = 0;

            // URL param can be used to change this.
            self.layoutResize = false;

            // if the display has a max size video then the div element for that.
            // a maximized size video is present for pip and max layouts
            self.maxvideo = null;
            self.resetLayoutMaxVideo = resetLayoutMaxVideo;

            // resize of videoroom component should re-position videos; collate all events in an interval.
            self.resizeTimer = null;

            self.updateVideosLayout = updateVideosLayout;
            self.updateVideosLayoutComplete = updateVideosLayoutComplete;
            self.applyBlackBgToMaxScreenIfNeeded = applyBlackBgToMaxScreenIfNeeded;
            self.setPictureInPictureLayout = setPictureInPictureLayout;

            // object-fit mode for various webcam videos. default (null) is cover. this can be used to change to contain.
            self.layoutObjectFit = null;

            // can be autohide, autoblur, autosize, auto or null.
            self.layoutPreview = null;
            self.initLayoutPreview = initLayoutPreview;

            self.layoutSelfPIP = true;

            // how small the picture-in-picture is compared to background video.
            // if compact mode, this is changed to 3.
            self.layoutFactorPIP = 5;
            // offset from the edge.
            // if compact mode, this is reset to 0.
            self.layoutOffsetPIP = 10;

            // whether to order the videos in the layout: null, "id", "name". additionally "true" ("name") and "false" (null) are allowed too.
            self.layoutOrder = null;

            self.onAnnotationToggled = onAnnotationToggled;
            self.onToggleFeedVisibility = onToggleFeedVisibility;
            self.showWebcamsVideos = true;
            self.VDIRef = helperService.getVDIRef();

            $scope.$on('change-videoroom-layout', onChangeVideoroomLayout);

            $scope.$on('toggled-annotation', onAnnotationToggled);

            $scope.$on('toggle-feed-visibility', onToggleFeedVisibility);

            $scope.$on('showing-top-bottom-controls', onShowingTopBottomControls);
        }

        // update state from config.
        function initLayout() {
            // layout method - allow URL param, fallback to user pair.
            self.layoutMethod = configService.getValue('layoutMethod');

            // layout trigger - default is dblclick
            self.layoutTrigger = configService.getValue('layoutTrigger');

            // layout resize
            var layoutResize = configService.getValue('layoutResize');
            self.layoutResize = layoutResize == 'true';

            // object fit for webcam videos.
            self.layoutObjectFit = configService.getValue('layoutObjectFit');
            if (self.layoutObjectFit) {
                $window.$('#videoroom-videos').attr('objectfit', self.layoutObjectFit);
            } else {
                $window.$('#videoroom-videos').removeAttr('objectfit');
            }

            // layout order
            self.layoutOrder = configService.getValue('layoutOrder');
            if (self.layoutOrder == 'false') {
                self.layoutOrder = null;
            }

            var preview = configService.getClientValue('preview');
            if (preview) {
                if (preview == 'no-mirror') {
                    $window.$('#videoroom-videos').attr('preview', 'no-mirror');
                } else {
                    $window.$('#videoroom-videos').removeAttr('preview');
                }
            }
        }

        function initLayoutPreview() {
            // layout preview - must be done after layoutPage is parsed.
            self.layoutSelfPIP = configService.getValue('layoutSelfPIP') !== 'false';
            var layoutPreview = configService.getValue('layoutPreview');
            if (layoutPreview && layoutPreview !== 'false') {
                self.layoutPreview = layoutPreview;
            } else {
                self.layoutPreview = null;
            }

            if (!self.layoutPageData.includeSelfVideo && self.layoutPreview) {
                $window.$('#videoroom-videos').attr('layoutpreview', self.layoutPreview);
            } else {
                $window.$('#videoroom-videos').removeAttr('layoutpreview');
            }

            if (self.layoutSelfPIP) {
                $window.$('#videoroom').attr('layoutselfpip', 'true');
                $window.$('#videoroom-videos').attr('layoutselfpip', 'true');
            } else {
                $window.$('#videoroom').removeAttr('layoutselfpip');
                $window.$('#videoroom-videos').removeAttr('layoutselfpip');
            }
        }

        function onToggleFeedVisibility(e, data) {
            if (data) {
                self.showWebcamsVideos = data.value;
                if (data.type === videoroomService.feedType.SHOW_ALL_WEBCAM_VIDEOS) {
                    if (self.isVideoTogglePaused(false) === data.value) {
                        self.onShowHideRemoteVideos(false);
                    }
                } else if (data.type === videoroomService.feedType.SHOW_SHARED_CONTENT) {
                    if (self.isVideoTogglePaused(true) === data.value) {
                        self.onShowHideRemoteVideos(true);
                        if (self.maxvideo) {
                            if (data.value === false) {
                                //hiding content
                                if ($window.$(self.maxvideo).is('.remote.screen')) {
                                    self.setCurrentLayout(videoroomService.layouts.GALLERY);
                                }
                            } else {
                                self.setCurrentLayout(videoroomService.layouts.SPOTLIGHT);
                            }
                        }
                    }
                }
            }
        }

        function onShowingTopBottomControls(e, data) {
            if (self.layoutPage && !self.layoutPageData.includeSelfVideo && self.layoutLock != 'locked') {
                $window.$('#videoroom-videos').attr('hascontrols', '' + data);
            }
        }

        function onChangeVideoroomLayout(e, data) {
            if (self.layoutLock == 'locked' && !self.isHost) {
                // only host can change locked layout.
                logger.log('videoroomCtrl cannot change locked layout if not host');
                return;
            }
            self.toggleDelay();
            if (data && data.newLayout !== undefined) {
                if (self.layoutPage) {
                    self.onLayoutPageShowLayout(data.newLayout);
                    return;
                }
                // TODO: delete the code below to avoid duplicate, once layoutPage part is tested.
                switch (data.newLayout) {
                    case videoroomService.layouts.SPOTLIGHT:
                        logger.log('videoroomCtrl changing layout to spotlight');
                        self.preferredLayout = 'spotlight';

                        //If content shared, set as spotlight
                        //If content not shared but client subscribed to other video feeds, set spotlight to first one available
                        //Otherwise, set spotlight to local shared video if available

                        var divToToggle =
                            $window.$('#videoroom-videos > div.remote.screen[enable="true"]').get(0) ||
                            $window.$('#videoroom-videos > div.remote[user][enable="true"]:not(.audioonly)').get(0) ||
                            $window.$('#videoroom-videos > div.local[enable="true"]:not(.audioonly)').get(0);

                        if (divToToggle && self.maxvideo !== divToToggle) {
                            self.toggleVideoFullsize(divToToggle);
                        } else {
                            //Not sure if this can happen in practice because user can only switch layouts when other feeds are available...
                            logger.log('videoroomCtrl unable to find a video to set as spotlight');
                        }

                        break;
                    case videoroomService.layouts.GALLERY:
                        logger.log('videoroomCtrl changing layout to gallery');
                        self.preferredLayout = 'grid';

                        if (self.maxvideo) {
                            self.toggleVideoFullsize(self.maxvideo);
                        }

                        break;
                    default:
                        logger.log(
                            'videoroomCtrl unable to change layout due to unsupported layout: ' + data.newLayout
                        );
                }
            }
        }

        // Update the layout of the video elements in the component. Note that only the enabled
        // video elements are displayed, and others are hidden. The general algorithm depends on the
        // number of visible video elements - for one element, it is full size; for two elements, if
        // one of them is local video, then picture-in-picture is used, with remote video as full
        // size and local video as smaller box on bottom right corner; otherwise multi-video layout
        // is done. For multi-video layout, if the max video property is present, then that full
        // size video is displayed on left or bottom sides, and all other videos are displayed in the
        // remaining space either on the right or on the top. If the max video property is not
        // present, then all the videos are displayed in the available (remaining) space. To display
        // multiple videos in the remaining space, a layout that minimizes the empty space is picked.
        // For this part there are three approaches controlled by the layoutMethod variable.
        // If "landscape" then the algorithm assumes aspect ratio of the video elements between
        // 16:9 and 1:1. If "fixed" then the algorithm allows aspect ratios of either 16:9 (landscape)
        // or 9:16 (portrait for mobile) based on the orientation attribute of the video element.
        // If "flexible" then the algorithm uses flexible aspect ratio of videos between
        // 16:9 to 1:1 for landscape and 9:16 to 1:1 for portrait orientations. By default if layoutMethod
        // is not set, then it assumes "flexible".
        function updateVideosLayout() {
            if (self.layoutPage && self.layoutPageData.pendingFlips.length > 0 && !self.isCompactMode) {
                // can't run update now, wait until flip is completed.
                self.layoutPageData.updateAfterFlip =
                    $window.$('#videoroom-videos').attr('animate') == 'false' ? 'noanimate' : 'animate';
                return;
            }

            if (self.layoutPage) {
                if (!self.hasTestLayout && (!self.janus || self.disconnectRetry > 0)) {
                    // reconnecting
                    self.updateLayoutAfterReconnect = true;
                    return;
                }

                if (self.onLayoutPageBeforeUpdate()) {
                    // slow down layout change in all hands
                    return;
                }

                // TODO: this restricts the receiver to also have layoutPage enabled.
                // host controls the layout by specifying the positions.
                if (self.onLayoutPageUpdateLockPositions()) {
                    // processed.
                    self.updateVideosLayoutComplete();
                    return;
                }
            }

            // round to one decimal digit.
            var round = function (value) {
                return Math.round(value * 10) / 10;
            };

            // whether new picture-in-picture video found?
            var draggable = null;

            // this is the available space.
            var W = $window.$('#videoroom-videos').innerWidth(),
                H = $window.$('#videoroom-videos').innerHeight();
            var W0 = W,
                H0 = H,
                x1 = 0,
                y1 = 0; // offset and size when locked layout

            if (self.layoutLock == 'locked') {
                if (W >= H * self.layoutLockData.ratio) {
                    W = H * self.layoutLockData.ratio;
                    x1 = W0 / 2 - W / 2;
                } else {
                    H = W / self.layoutLockData.ratio;
                    y1 = H0 / 2 - H / 2;
                }
            }

            var ratio1 = self.idealAspectRatio,
                ratio2 = self.minAspectRatio;
            var w0 = 0,
                h0 = 0; // the width and height of the individual video elements.
            var x0 = 0,
                y0 = 0; // position of the individual video elements.

            // this code snippet has been moved from top/begining to here.
            var total = $window.$('#videoroom-videos > div:not(.audioonly):not(.video-avatar-container)').length;
            $window.$('#videoroom-videos').attr('total', '' + total);

            // number of visible video elements is used in the layout algorithm.
            var visible;
            var input = [],
                output = [],
                videoDivs;

            var includeSelfVideo = self.layoutPageData.includeSelfVideo;

            if (self.layoutPage) {
                if (!includeSelfVideo && self.layoutLock != 'locked') {
                    videoDivs = [].slice.call(
                        $window.$(
                            '#videoroom-videos > div[user]:not(.audioonly):not(.local):not(.video-avatar-container)'
                        )
                    );
                } else {
                    videoDivs = [].slice.call(
                        $window.$('#videoroom-videos > div[user]:not(.audioonly):not(.video-avatar-container)')
                    );
                }

                if (self.layoutSelfPIP && includeSelfVideo && !self.isCompactMode) {
                    if (videoDivs.length === 1 && videoDivs[0].className.match(/\blocal\b/)) {
                        videoDivs.splice(0, 1);
                        includeSelfVideo = false;
                    }
                }

                if (self.layoutPageData.layout == 'allhands') {
                    output = self.getLayoutPageAllHands(videoDivs, input, W, H, ratio1, ratio2); // updates videoDivs and input.
                    visible = output.length;
                } else {
                    input = self.getLayoutInputVideos(videoDivs); // can update videoDivs too
                    visible = input.length;
                }

                if (self.layoutPopout) {
                    visible = self.onPopoutUpdateDisplayed(videoDivs, input, output);
                }
            } else {
                videoDivs = [].slice.call($window.$('#videoroom-videos > div[enable="true"]:not(.audioonly)'));
                visible = videoDivs.length;
                if (
                    self.layoutSelfPIP &&
                    !self.isCompactMode &&
                    videoDivs.length === 1 &&
                    videoDivs[0].className.match(/\blocal\b/)
                ) {
                    visible = 0;
                }
            }

            self.logLayout('updateVideosLayout() visible=' + visible + ',total=' + total);
            // hide all the disabled videos first.
            if (!self.isCompactMode) {
                $window
                    .$('#videoroom-videos > div[enable="false"], #videoroom-videos > div.audioonly')
                    .attr('style', 'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;');

                $window.$('#videoroom-videos').attr('visible', '' + visible);
                $window.$('#videoroom').attr('visible', !!visible);
            }
            try {
                // has exception (in angular: $$nextSibling of null) sometimes, when meeting ends.
                $rootScope.$broadcast('video-room-webcams-visible', !!visible);
            } catch (e) {
                // ignore the exception
            }

            var layoutMethod =
                self.layoutMethod || (visible <= self.maxVideoCountForFlexibleLayout ? 'flexible' : 'landscape');
            var match = layoutMethod.match(/^(\w+),(\w+)$/);
            if (match) {
                if (visible <= self.maxVideoCountForFlexibleLayout) {
                    layoutMethod = match[1] || 'flexible';
                } else {
                    layoutMethod = match[2] || 'landscape';
                }
            }

            // reapply the zoom on video elements if needed on resize
            $window.$('#videoroom-videos > div').each(function (index, div) {
                if (div.zoomData) {
                    self.reapplyZoomAfter(div);
                }
            });

            if (
                (!(self.layoutPage && self.layoutPageData.layout == 'allhands') &&
                    !(self.layoutPage && !includeSelfVideo) &&
                    (visible <= 1 ||
                        (visible == 2 &&
                            $window.$('#videoroom-videos div.local[enable="true"]:not(.audioonly)').length > 0 &&
                            self.layoutLock != 'locked'))) ||
                self.isCompactMode
            ) {
                // if not multi-video layout. PIP is disabled for locked layout.
                w0 = W;
                h0 = H;
                var div_l, div_s;
                if (visible <= 1 && (!self.isCompactMode || attendeeListService.getAttendeeList().length <= 1)) {
                    // for one video, use full available size.
                    div_l = $window.$('#videoroom-videos > div[enable="true"]:not(.audioonly)');

                    if (self.layoutSelfPIP && div_l.hasClass('local') && !self.isCompactMode) {
                        div_s = div_l;
                        div_l = null;
                    }
                } else {
                    // for two videos where one is local view, make the remote video as full available size.
                    // in compact mode default smaller video element to be local
                    var local_max =
                        !self.isCompactMode && !!(self.maxvideo && self.maxvideo.className.match(/\blocal\b/));

                    div_l = $window.$(
                        '#videoroom-videos > div.' +
                            (local_max ? 'local' : 'remote') +
                            '[enable="true"]:not(.audioonly)'
                    );
                    div_s = $window.$(
                        '#videoroom-videos > div.' +
                            (local_max ? 'remote' : 'local') +
                            '[enable="true"]:not(.audioonly)'
                    );
                }

                if (div_l) {
                    div_l.each(function () {
                        let div_v = $window.$(this);
                        let x = x0,
                            y = y0,
                            w = w0,
                            h = h0;

                        if (layoutMethod != 'landscape') {
                            if (div_v.attr('orientation') == 'portrait' && w / h > ratio2) {
                                // too much zoom, change to ratio2
                                w = h / ratio2;
                                x = W / 2 - w / 2;
                            } else if (div_v.attr('orientation') != 'portrait' && w / h < ratio2) {
                                h0 = w * ratio2;
                                y = H / 2 - h / 2;
                            }
                        }

                        x = x + x1;
                        y = y + y1;

                        div_v.attr(
                            'style',
                            'left: ' +
                                round(x) +
                                'px; top: ' +
                                round(y) +
                                'px; width: ' +
                                round(w) +
                                'px; height: ' +
                                round(h) +
                                'px;'
                        );
                    });
                }

                if (self.isCompactMode) {
                    self.compactAddAvatarIfNeeded();
                    self.compactAssignTalkerOnUpdateLayout();
                }

                if (div_s) {
                    self.setPictureInPictureLayout(div_s, W, H, ratio1, x1, y1, layoutMethod, round);
                    draggable = div_s.get(0);
                }
            } else {
                // else if multi-video layout
                if (self.layoutPage) {
                    if (!includeSelfVideo && self.layoutLock != 'locked') {
                        var div_p = $window.$('#videoroom-videos > div.local[enable="true"]:not(.audioonly)');
                        if (div_p.length > 0) {
                            self.setPictureInPictureLayout(div_p, W, H, ratio1, x1, y1, layoutMethod, round);
                            draggable = div_p.get(0);
                        }
                    }

                    // pagination is enabled. pinned videos are handled here too.
                    if (self.layoutPageData.layout == 'allhands') {
                        layoutMethod = 'landscape'; // do not use flexible here.
                    } else {
                        // run the multi-video layout algorithm
                        output = videoLayoutAlgorithmService.findBestLayout(layoutMethod, input, W, H, ratio1, ratio2);
                    }
                    //console.log('size=' + videoDivs.length + ',' + input.length);
                } else {
                    // keep the original code, do not refactor for now.
                    // determine the input orientations of all videos
                    if (self.layoutPin) {
                        // move pinned videos to the beginning.
                        self.setLayoutPinnedVideos(videoDivs);
                    }

                    videoDivs.forEach(function (element, index) {
                        var item = element.getAttribute('orientation') == 'portrait' ? 'p' : 'l';
                        if (element == self.maxvideo) {
                            item = item.toUpperCase();
                        }
                        input.push(item);
                    });

                    // run the multi-video layout algorithm
                    output = videoLayoutAlgorithmService.findBestLayout(layoutMethod, input, W, H, ratio1, ratio2);
                }

                // apply the result to all the videos.
                videoDivs.forEach(function (element, index) {
                    var item = output[index];
                    var x = item.x + x1;
                    var y = item.y + y1;
                    var style_str =
                        'left: ' +
                        round(x) +
                        'px; top: ' +
                        round(y) +
                        'px; width: ' +
                        round(item.w) +
                        'px; height: ' +
                        round(item.h) +
                        'px;';
                    // accommodate for portrait video in landscape layoutMethod, by adding left-right thick border
                    if (
                        !(layoutMethod === null || layoutMethod == 'flexible' || layoutMethod == 'fixed') && // for landscape and others
                        (input[index] == 'p' || input[index] == 'P')
                    ) {
                        if (item.w > item.h) {
                            var border = item.w / 2 - item.h / 2 - 2.0; // offset to avoid thin background line.
                            style_str +=
                                ' border-left-width: ' +
                                round(border) +
                                'px; border-right-width: ' +
                                round(border) +
                                'px;';
                        }
                    }
                    $window.$(element).attr('style', style_str);
                });
            }

            // ability to drag the local picture-in-picture video. after drag, move it to one of the corners.
            if (draggable != self.draggableVideo) {
                if (self.draggableVideo) {
                    try {
                        $window.$(self.draggableVideo).draggable('destroy');
                    } catch (e) {}
                }
                self.draggableVideo = draggable;
                if (self.draggableVideo) {
                    $window.$(self.draggableVideo).draggable({
                        start: e => {
                            if (annotationService.getIsLocalAnnotationEnabled()) {
                                e.preventDefault();
                            }
                        },
                        stop: onDraggedVideoStopped
                    });
                }
            }

            self.updateVideosLayoutComplete();

            // host will inform about layout change to others
            if (self.layoutLock == 'locked' && self.isHost) {
                var children = [].slice.call($window.$('#videoroom-videos > div[enable="true"]:not(.audioonly)'));
                self.layoutLockData.method = layoutMethod;
                self.layoutLockData.spotlight = self.maxvideo ? self.maxvideo.getAttribute('user') : null;
                self.layoutLockData.items = children.map(function (div) {
                    return div.getAttribute('user');
                });

                if (self.layoutPage) {
                    self.onLayoutPageUpdateLockData(); // updates self.layoutLockData if needed
                }

                var list = attendeeListService.getAttendeeList();
                logger.log(
                    'videoroomCtrl sending update-videos-layout to ' +
                        ((list && list.length - 1) || null) +
                        ' attendees: ' +
                        JSON.stringify(self.layoutLockData)
                );
                if (list) {
                    list.forEach(function (attendee) {
                        if (attendee) {
                            if (attendee.attendantId != self.attendantId) {
                                socketService.send({
                                    message: 'attendee-message',
                                    data: {
                                        type: 'update-videos-layout',
                                        to: attendee.attendantId,
                                        data: self.layoutLockData
                                    }
                                });
                            }
                        }
                    });
                }
            }
        }

        // separated out from updateVideosLayout so that unittest can be done on this.
        function updateVideosLayoutComplete() {
            // update video background to black for spotlight screen video under certain conditions.
            if (self.maxvideo && $window.$(self.maxvideo).hasClass('screen')) {
                self.applyBlackBgToMaxScreenIfNeeded();
                // ANYAM-15422 - due to animation/transition of video sizes, it may take upto 0.3s to get the correct size.
                // so invoke this again just to be safe.
                $timeout(function () {
                    if (self.maxvideo && $window.$(self.maxvideo).hasClass('screen')) {
                        self.applyBlackBgToMaxScreenIfNeeded();
                    }
                }, 400);
            }

            self.onLayoutPageUpdateComplete();
        }

        // if the aspect ratio of the video (videoWidth/videoHeight) is more than the
        // display aspect ratio for the spotlight screen video, AND the remaining videos
        // are displayed on top (or bottom) of spotlight video, THEN display a black background
        // instead of transparent for that video (see ANYAM-14639)
        function applyBlackBgToMaxScreenIfNeeded() {
            var video = $(self.maxvideo)[0].querySelector('video');
            if (
                video &&
                video.videoWidth > 0 &&
                video.videoHeight > 0 &&
                self.maxvideo.offsetWidth > 0 &&
                self.maxvideo.offsetHeight > 0
            ) {
                var ratio1 = video.videoWidth / video.videoHeight;
                var ratio2 = self.maxvideo.offsetWidth / self.maxvideo.offsetHeight;
                var condition = ratio1 > ratio2 && !videoLayoutAlgorithmService.hasWideSpotlight();
                $(self.maxvideo).attr('blackbg', '' + condition);
            }
        }

        function setPictureInPictureLayout(div_s, W, H, ratio1, x1, y1, layoutMethod, round) {
            // then make the local video as at most 20% of the full available size
            // (larger of the width or height side), and
            // anchor it to the bottom right corner, at a marginal offset.
            // The position attribute may indicates another anchor position -
            // top-left, top-right, bottom-left, bottom-right.

            var w = W >= H * ratio1 ? W / self.layoutFactorPIP : (H * ratio1) / self.layoutFactorPIP;
            var h = w / ratio1;

            if (layoutMethod != 'landscape') {
                if (div_s.attr('orientation') == 'portrait') {
                    var t = w;
                    w = h;
                    h = t;
                }
            }

            var pos = $window.$('#videoroom-videos > div.local').attr('position') || 'bottom-right';

            var x = pos == 'top-left' || pos == 'bottom-left' ? self.layoutOffsetPIP : W - self.layoutOffsetPIP - w;

            var y = pos == 'top-left' || pos == 'top-right' ? self.layoutOffsetPIP : H - self.layoutOffsetPIP - h;

            x = x + x1;
            y = y + y1;

            div_s.attr(
                'style',
                'z-index: 3; left: ' +
                    round(x) +
                    'px; top: ' +
                    round(y) +
                    'px; width: ' +
                    round(w) +
                    'px; height: ' +
                    round(h) +
                    'px;'
            );
        }

        function getShowWebcams() {
            return self.showWebcamsVideos;
        }

        function setShowWebcams(showWebcams) {
            self.showWebcamsVideos = showWebcams;
        }

        // animate-move the PIP video to one of the corners closest to drag stop position.
        function onDraggedVideoStopped(event, ui) {
            logger.log('videoroomCtrl stopped dragging...');
            var w = ui.helper.width(),
                h = ui.helper.height();
            var CX = $window.$('#videoroom-videos').width() / 2,
                CY = $window.$('#videoroom-videos').height() / 2;
            var cx = ui.position.left + w / 2,
                cy = ui.position.top + h / 2;
            var pos = '',
                left = 10,
                top = 10;
            if (cx <= CX && cy <= CY) {
                // top-left
                pos = 'top-left';
            } else if (cx > CX && cy <= CY) {
                // top-right
                pos = 'top-right';
                left = Math.round(2 * CX - w - 10);
            } else if (cx <= CX && cy > CY) {
                // bottom-left
                pos = 'bottom-left';
                top = Math.round(2 * CY - h - 10);
            } else if (cx > CX && cy > CY) {
                // bottom-right
                pos = 'bottom-right';
                left = Math.round(2 * CX - w - 10);
                top = Math.round(2 * CY - h - 10);
            }
            $window.$('#videoroom-videos div.local[enable="true"]').attr('position', pos);
            $timeout(function () {
                $window.$(self.draggableVideo).animate(
                    {
                        left: left,
                        top: top
                    },
                    0,
                    function () {
                        // this will assign left, right, top, bottom correctly.
                        self.updateVideosLayout();
                    }
                );
            }, 0);
            if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                $rootScope.$broadcast('vdi-reshow-annotation-ui');
            }
        }

        function onAnnotationToggled(evt, toggled) {
            var element = null;
            try {
                element = $window.$('#videoroom-videos > div.remote.screen.primary')[0];
                if (toggled) {
                    self.restoreVideoElement(element);
                    element.removeEventListener('mousedown', self.onVideoMouseDown);
                } else {
                    element.addEventListener('mousedown', self.onVideoMouseDown);
                }
            } catch (err) {
                logger.error('onAnnotationToggled', 'screen share feed not found', err);
            }
        }

        function resetLayoutMaxVideo(val) {
            self.maxvideo = val;
        }
    }
]);
